<script>
  import { computed, ref, onMounted, onBeforeUnmount } from '@nuxtjs/composition-api'
  import CarouselBase from '@/components/CarouselBase'
  import { useCarousel } from '@/composables/useCarousel'
  import Tool from './Tool.vue'

  export default {
    components: {
      CarouselBase,
      Tool,
    },
    props: {
      content: {    
        type: Array,
        required: true
      }
    },
    setup (props) {
      const {
        hasNext,
        hasPrev,
        next,
        prev,
        slide
      } = useCarousel()
      const isDesktop = ref(false)

      const checkScreenSize = () => {
        isDesktop.value = window.innerWidth >= 768 // md breakpoint
      }

      onMounted(() => {
        checkScreenSize()
        window.addEventListener('resize', checkScreenSize)
      })

      onBeforeUnmount(() => {
        window.removeEventListener('resize', checkScreenSize)
      })

      const sliderIsNotNeededOnDesktop = computed(() => {
        return props.content.length <= 3
      });

      const contentInfo = computed(() => {
        return props.content
      })
      return {
        contentInfo,
        sliderIsNotNeededOnDesktop,
        hasNext,
        slide,
        next,
        prev,
        hasPrev, 
        isDesktop,
      }
    }
  }
</script>

<template>
  <div
    class="md:px-12 container mx-auto mt-12"
  >
    <h2 class="text-2xl md:text-3xl font-bold mb-8 px-4 text-center">
      Handige tools
    </h2>
    <div class="relative w-full home-carousel-wrapper">
      <CarouselBase
        class="pt-1 pb-1"
        :active-slide="slide"
        :items="content"
        show-progress
        :small-slider="!isDesktop"
        @slide-change="slide = $event"
        @has-next="hasNext = $event"
        @next="next"
        @prev="prev"
      >
        <div
          v-for="(carouselSlide, index) in content"
          :key="index"
          class="slide"
        >
          <transition
            name="fade"
            mode="out-in"
          >
            <Tool :tool="carouselSlide" />
          </transition>
        </div>
      </CarouselBase>
      <div
        class="px-4"
        :class="{'md:hidden': sliderIsNotNeededOnDesktop}"
      >
        <ul class="flex flex-row justify-center gap-2 my-4 align-center carousel-dots">
          <li
            v-for="(tool, index) in content"
            :key="index"
          >
            <button
              type="button"
              class="w-2 h-2 bg-gray-500 rounded-full block"
              :class="{'bg-blue-500': slide === index}"
              :aria-label="`Ga naar dia ${index + 1}`"
              @click="slide = index"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.home-carousel-wrapper {
  .slide {
    width: 300px;

    @screen md {
      width: calc(100% / 3 - 3.75rem) !important;
    }

    @screen lg {
      width: calc(100% / 3 - 1rem) !important;
    }

    &:last-child {
      @screen md {
        margin-right: 0 !important;
      }
    }
  }
.carousel-base .carousel-slides-wrapper {
  @screen md {
    cursor: initial !important;
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
  }
}


  .carousel-controls {
    button {
      @apply pointer-events-auto;
      @apply bg-white;

      &:first-child {
        transform: translateX(-2rem);
      }
      &:last-child {
        transform: translateX(2rem);
      }
    }
  }
}
</style>
